export const TEST_IDS_MEDIA = {
  add: 'add-media-btn',
  edit: 'edit-media-btn',
  remove: 'remove-media-btn',
};
